<script>
import {
  ArticleEditorElementMixin,
} from "%/dynamic-component-editor/standard-elements/articles/shared/article-editor-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";

export default {
  name: "SavingStatus",
  elementPanelSettings: {
    displayName: "Saving Status",
    displayIcon: "pencil",
    elementGroup: "articleElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [ArticleEditorElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return this.savingStatus;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
